import { LOAN_CALCULATE_SET_VALUE } from "../../../actions/fauluLoanCalculator/fauluLoanCalculatorForm";
import { COLLECT_LOGIN_DETAILS} from "../../../actions/fauluLoanCalculator/auth"
import { fauluLoanCalculatorService } from "./fauluLoanCalculator";
import { loginService } from "./login";

export const fauluLoanCalculator = (store, next, action) => {
    if (action.type.startsWith(LOAN_CALCULATE_SET_VALUE)) {
        return fauluLoanCalculatorService(store, next, action);
    }

    if(action.type.startsWith(COLLECT_LOGIN_DETAILS)){ 
        return loginService(store, next, action);
    }
}